import clsx from 'clsx';
import { Row, Rows } from 'common/types/scalarSpreadsheet';
import { FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMN_KEY_PREFIX } from 'pages/FundInvestments/common/constants';
import { FundInvestmentMarketAdjustmentCellData } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet';
import { CompanyInfoDialog } from 'pages/Valuations/components/CompanyInfoDialog';
import CompGroupRowHeader from 'pages/Valuations/components/CompGroupRowHeader';
import { generateColumnKey, getArrayValue, getNumberValue, getObjectValue, getStringValue } from 'utilities';
import { CreateCompanyIndexRowsParams } from './createCompanyIndexRows.types';

const createCompanyIndexRows = (params: CreateCompanyIndexRowsParams): Rows => {
  const { displayOnlyIndexes = false, marketCurrency, uniqueComparisons } = params;

  const filteredComparisons = getArrayValue(uniqueComparisons).filter(
    comparison => comparison.is_index === displayOnlyIndexes
  );

  const comparisonsCount = getNumberValue(filteredComparisons?.length);

  const comparisonRows = filteredComparisons.map((comparison, index) => {
    const {
      cap_iq_id: capIqId,
      company_name: companyName,
      id: comparisonId,
      is_index: isIndex,
      order,
      ticker_symbol: tickerSymbol,
    } = getObjectValue(comparison);

    const columnKey = generateColumnKey({
      id: getStringValue(capIqId),
      name: getStringValue(tickerSymbol),
      prefix: FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      alias: columnKey,
      data: {
        capIqId,
        comparisonId,
        isIndex,
        name: companyName, // Display the companyName on confirm delete dialog
        order,
        tickerSymbol,
      } as FundInvestmentMarketAdjustmentCellData,
      gridType: 'string',
      isDeletableRow: true,
      readOnly: true,
      className: clsx({ 'division-bottom-only': index === comparisonsCount - 1 }),
      value: (
        <CompGroupRowHeader
          allowShowCompanyDialog
          companyDialogComponent={CompanyInfoDialog}
          comparisonData={comparison}
          compGroupData={null}
          currency={marketCurrency}
          value={getStringValue(companyName)}
        />
      ),
    } as Row;
  });

  return comparisonRows;
};

export default createCompanyIndexRows;
